import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AboutUs.css";
import aboutHeroImage from "../../assets/Truredifference-1.png";
import aboutExplainerImage from "../../assets/about-2.jpg";
import about31 from "../../assets/about-3-1.png";
import about32 from "../../assets/about-3-2.png";
import about33 from "../../assets/about-3-3.png";
import about4 from "../../assets/about-4.png";
import about51 from "../../assets/about-5-1.png";
import about52 from "../../assets/about-5-2.png";
import about53 from "../../assets/about-5-3.png";
import about54 from "../../assets/about-5-4.png";
import about55 from "../../assets/about-5-5.png";
import about56 from "../../assets/about-5-6.png";

import trueRenewablesLogo from "../../assets/hiw_logo.svg";
import finalStep1 from "../../assets/finalstep1.png";
import finalStep2 from "../../assets/finalstep2.png";
import finalStep3 from "../../assets/finalstep3.png";
import s1step1 from "../../assets/stage-1-1.png";
import s1step2 from "../../assets/stage-1-2.png";
import s1step3 from "../../assets/stage-1-3.png";
import s1step4 from "../../assets/stage-1-4.png";
import s1step5 from "../../assets/stage-1-5.png";
import s2step1 from "../../assets/stage-2-1.png";
import s2step2 from "../../assets/stage-2-2.png";
import s2step3 from "../../assets/stage-2-3.png";
import s2step4 from "../../assets/stage-2-4.png";
import s2step5 from "../../assets/home-stage2-step5.png";
import s3step1 from "../../assets/stage-3-1.png";
import s3step2 from "../../assets/stage-3-2.png";
import s3step3 from "../../assets/stage-3-3.png";
import s3step4 from "../../assets/stage-3-4.png";
import s3step5 from "../../assets/stage-3-5.png";
import s4step1 from "../../assets/stage-4-1.png";
import s4step2 from "../../assets/stage-4-2.png";
import s4step3 from "../../assets/stage-4-3.png";
import s4step4 from "../../assets/stage-4-4.png";
import s4step5 from "../../assets/stage-4-5.png";
import s5step1 from "../../assets/stage-5-1.png";
import s5step2 from "../../assets/stage-5-2.png";
import s5step3 from "../../assets/stage-5-3.png";
import s5step4 from "../../assets/stage-5-4.png";
import s5step5 from "../../assets/stage-5-5.png";
import s6step1 from "../../assets/stage-6-1.png";
import s6step2 from "../../assets/stage-6-2.png";
import s6step3 from "../../assets/stage-6-3.png";
import s6step4 from "../../assets/stage-6-4.png";
import s6step5 from "../../assets/home-stage6-step5.png";
import s7step1 from "../../assets/stage-7-1.png";
import s7step2 from "../../assets/stage-7-2.png";
import s7step3 from "../../assets/stage-7-3.png";
import s7step4 from "../../assets/stage-7-4.png";
import s7step5 from "../../assets/pmkusum-stage7-step5.png";
import s7step6 from "../../assets/stage-7-6.png";
import s8step1 from "../../assets/stage-8-1.png";
import s8step2 from "../../assets/stage-8-2.png";
import s8step3 from "../../assets/stage-8-3.png";
import s8step4 from "../../assets/stage-8-4.png";
import s8step5 from "../../assets/stage-8-5.png";
import s8step6 from "../../assets/stage-8-6.png";
import s9step1 from "../../assets/stage-9-1.png";
import s9step2 from "../../assets/stage-9-2.png";
import s9step3 from "../../assets/stage-9-3.png";
import s9step4 from "../../assets/stage-9-4.png";
import s9step5 from "../../assets/stage-9-5.png";
import s10step1 from "../../assets/stage-10-1.png";
import s10step2 from "../../assets/stage-10-2.png";
import s10step3 from "../../assets/stage-10-3.png";
import s10step4 from "../../assets/stage-10-4.png";
import s10step5 from "../../assets/stage-10-5.png";
import s10step6 from "../../assets/stage-10-6.png";
import s11step1 from "../../assets/stage-11-1.png";
import s11step2 from "../../assets/stage-11-2.png";
import s11step3 from "../../assets/stage-11-3.png";
import s11step4 from "../../assets/stage-11-4.png";
import s11step5 from "../../assets/stage-11-5.png";
import s11step6 from "../../assets/stage-11-6.png";
import s12step1 from "../../assets/stage-12-1.png";
import s12step2 from "../../assets/stage-12-2.png";
import s12step3 from "../../assets/stage-12-3.png";
import s12step4 from "../../assets/stage-12-4.png";
import s12step5 from "../../assets/stage-12-5.png";
import s12step6 from "../../assets/stage-12-6.png";

import complianceImg1 from "../../assets/trcr-section11-img1.png";
import complianceImg2 from "../../assets/trcr-section11-img2.png";

import truerenewableslogo from "../../assets/truerenewables_logo.svg";

import modularImg1 from "../../assets/RRsection5-1.png";
import modularImg2 from "../../assets/captive-section-1.png";
import modularImg3 from "../../assets/about-9-3.png";
import modularImg4 from "../../assets/GCsection1.png";
import modularImg5 from "../../assets/about-9-5.png";
import modularImg6 from "../../assets/PMKusumsection1.png";
import modularImg7 from "../../assets/about-9-7.png";
import modularImg8 from "../../assets/about-9-8.png";

import about10 from "../../assets/about-10.png";
import about11 from "../../assets/about-11.png";






/* ================================================
   SECTION 1 — HERO
   ================================================ */
const AboutHero = () => {
  const navigate = useNavigate();

  return (
    <section className="about-hero">
      <div className="about-hero__content">
        <h1 className="about-hero__heading">
          Advanced Energy Intelligence.
          <br />
          Zero-Stress Execution.
          <br />
          One Seamless Solar Ecosystem.
        </h1>

        <p className="about-hero__desc">
          A complete solar ecosystem—engineered, digitized, and managed
          end-to-end for effortless, transparent performance.
        </p>

        <div className="about-hero__cta">
          <button onClick={() => navigate("/contact")}>
            Book A Free Call
          </button>
        </div>
      </div>

      <div className="about-hero__image-wrap">
        <img
          src={aboutHeroImage}
          alt="True Renewables solar ecosystem"
          className="about-hero__image"
        />
      </div>
    </section>
  );
};

/* ── shared reveal hook ── */
const useReveal = () => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const check = () => {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.65) {
        el.classList.add("is-visible");
        window.removeEventListener("scroll", check);
      }
    };
    const timer = setTimeout(() => {
      window.addEventListener("scroll", check, { passive: true });
      check();
    }, 400);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", check);
    };
  }, []);
  return ref;
};

const aboutIntegrationCards = [
  {
    id: 1,
    title: "TrueTrack™ — EPC Intelligence Platform",
    desc: "Real-time progress tracking, milestone management, quality assurance workflows, and client dashboards — all in one transparent EPC platform.",
    imgMain: about31,
    path: "/truetrack"
  },
  {
    id: 2,
    title: "TrueCare™ — AI-Powered O&M & Performance Monitoring",
    desc: "IoT + SCADA monitoring, predictive maintenance, fault alerts, PR/CUF analytics, and AMC automation for maximum uptime and long-term performance.",
    imgMain: about32,
    path: "/truecare"
  },
  {
    id: 3,
    title: "TrueCom™ — Commercial, Billing & Compliance Automation",
    desc: "Automated invoicing, open access charge reconciliation, carbon credit issuance, payment/EMI tracking, and performance dashboards.",
    imgMain: about33,
    path: "/truecom"
  },
];

/* ================================================
   SECTION 2 — ABOUT EXPLAINER
   ================================================ */
const AboutExplainer = () => {
  return (
    <section className="about-model">
      <div className="about-model-container">
        <div className="about-model__content">
          <div>
            <p className="about-model__intro">
              AI-driven. Digital-first. Lifecycle-managed.
            </p>

            <p className="about-model__sub-heading">
              Where most EPCs stop at installation, we go 10 layers deeper:
            </p>

            <ul className="about-model__list">
              <li>Proprietary AI-driven monitoring</li>
              <li>Fully automated billing and compliance</li>
              <li>Predictive maintenance</li>
              <li>Real-time project intelligence</li>
              <li>Transparent digital dashboards</li>
              <li>Smart energy analytics</li>
              <li>25-year lifecycle tracking</li>
            </ul>
          </div>

          <p className="about-model__tagline">
            Every part of your solar journey — <strong>EPC, O&M, and commercial management</strong> — is connected through a unified digital ecosystem.
          </p>
        </div>

        <div className="about-model__image-wrap">
          <img
            src={aboutExplainerImage}
            alt="True Renewables solar engineer"
            className="about-model__image"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

/* ================================================
   SECTION 3 — THE TRUE DIGITAL ECOSYSTEM (360)
   ================================================ */
const AboutEcosystem = () => {
  const navigate = useNavigate();
  const cardRefs = useRef([]);
  const rafRef = useRef(null);
  const headerRef = useReveal();
  const footerRef = useReveal();

  useEffect(() => {
    const sectionEl = cardRefs.current[0]?.closest(".about-cir-section");

    const update = () => {
      if (!sectionEl) return;
      const sectionRect = sectionEl.getBoundingClientRect();
      const scrolled = Math.max(0, -sectionRect.top);
      const maxScroll = Math.max(
        1,
        sectionEl.offsetHeight - window.innerHeight,
      );
      const t = Math.min(1, scrolled / maxScroll);
      const globalScale = 1 - t * 0.12;

      cardRefs.current.forEach((card) => {
        if (!card) return;
        card.style.transform = `scale(${globalScale})`;
      });

      rafRef.current = null;
    };

    const onScroll = () => {
      if (!rafRef.current) rafRef.current = requestAnimationFrame(update);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    update();
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, []);

  return (
    <section className="about-cir-section">
      <div className="about-cir-container">
        {/* Header */}
        <div className="about-cir-header reveal-block" ref={headerRef}>
          <p className="about-cir-tag">
            <span className="about-cir-dot" />
            TRUECARE 360
          </p>
          <h2 className="about-cir-title">
            The True Digital Ecosystem
          </h2>
          <p className="about-cir-subtitle">
            No other company in India offers a full-stack digital solar ecosystem.
          </p>
        </div>

        {/* Cards */}
        <div className="about-cir-cards">
          {aboutIntegrationCards.map((card, index) => (
            <div
              key={card.id}
              className="about-cir-card"
              style={{ top: `${80 + index * 20}px`, zIndex: index + 1 }}
              ref={(el) => (cardRefs.current[index] = el)}
            >
              <div className="about-cir-left">
                <span className="about-cir-card-dot" />
                <div className="about-cir-left-inner">
                  <h3>{card.title}</h3>
                  <p>{card.desc}</p>
                  <button className="about-cir-btn" onClick={() => navigate(card.path)}>
                    Learn More
                  </button>
                </div>
                <span className="about-cir-card-dot" />
              </div>
              <div className="about-cir-right">
                <img
                  src={card.imgMain}
                  alt={card.title}
                  className="about-cir-img-main"
                  loading="lazy"
                />
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="about-cir-footer reveal-block" ref={footerRef}>
          Together, TrueTrack + TrueCare + TrueCom =
          <br />
          <strong>The only complete 360° solar lifecycle platform in India.</strong>
        </div>
      </div>
    </section>
  );
};

/* ================================================
   SECTION 4 — ENGINEERING STANDARDS (WHY CHOOSE US)
   ================================================ */
const AboutWhyChooseUs = () => {
  const headerRef = useReveal();

  const leftCards = [
    { num: "01", text: "Tier-1 modules only (TOPCon / N-Type / Bifacial)." },
    { num: "02", text: "Industrial-grade inverter architecture." },
    { num: "03", text: "Structural engineering for 150–180 km/h wind zones." },
  ];

  const rightCards = [
    { num: "04", text: "Thermal modeling, cable derating, and safety redundancy." },
    { num: "05", text: "Digital QA checklists at every EPC stage." },
    { num: "06", text: "European-quality workmanship & safety protocols." },
  ];

  return (
    <section className="about-why">
      <div className="about-why-header reveal-block" ref={headerRef}>
        <p className="about-why-tag">
          <span className="about-why-dot" />
          WHY CHOOSE US
        </p>
        <h2 className="about-why-title">
          Engineering Standards That
          <br />
          Belong To The Future
        </h2>
      </div>

      <div className="about-why-body">
        <div className="about-why-col">
          {leftCards.map((c) => (
            <div className="about-why-card" key={c.num}>
              <p className="about-why-num">{c.num}</p>
              <p className="about-why-text">{c.text}</p>
            </div>
          ))}
        </div>

        <div className="about-why-img-wrap">
          <img src={about4} alt="Engineering Standards" className="about-why-img" loading="lazy" />
        </div>

        <div className="about-why-col">
          {rightCards.map((c) => (
            <div className="about-why-card" key={c.num}>
              <p className="about-why-num">{c.num}</p>
              <p className="about-why-text">{c.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const aboutCapItems = [
  { icon: about51, label: "PR Drop\nAlerts" },
  { icon: about52, label: "String-Level\nAnalytics" },
  { icon: about53, label: "Degradation Trend\nForecasting" },
  { icon: about54, label: "Real-Time Inverter\nDiagnostics" },
  { icon: about55, label: "AI-Based Weather-Adjusted\nPerformance Models" },
  { icon: about56, label: "Drone Thermography\nIntegration" },
];

/* ================================================
   SECTION 5 — AI-ENHANCED MONITORING (CAPABILITIES)
   ================================================ */
const AboutCapabilities = () => {
  const headerRef = useReveal();
  const footerRef = useReveal();

  return (
    <section className="about-cap-section">
      <div className="about-cap-header reveal-block" ref={headerRef}>
        <p className="about-cap-tag">
          <span className="about-cap-dot" />
          SMART O&M SYSTEMS
        </p>
        <h2 className="about-cap-title">
          AI-Enhanced Monitoring &amp;
          <br />
          Predictive Maintenance
        </h2>
        <p className="about-cap-subtitle">
          From reactive service to automated intelligence.
        </p>
      </div>

      <div className="about-cap-grid">
        {aboutCapItems.map((cap, i) => (
          <div className="about-cap-item" key={i}>
            <img src={cap.icon} alt={cap.label} className="about-cap-icon" loading="lazy" />
            <p className="about-cap-label">{cap.label}</p>
          </div>
        ))}
      </div>

      <p className="about-cap-footer reveal-block" ref={footerRef}>
        Your plant is monitored like a mission-control center.
      </p>
    </section>
  );
};

const stages = [
  {
    id: 1,
    title: "Feasibility & Site Asessment",
    steps: [
      { title: "Land assessment (topography, contour, soil testing)", image: s1step1 },
      { title: "Irradiation analysis & shadow simulation", image: s1step2 },
      { title: "Grid proximity & evacuation feasibility", image: s1step3 },
      { title: "Access road & logistics evaluation", image: s1step4 },
      { title: "Preliminary DISCOM feasibility fitment", image: s1step5 },
    ],
  },
  {
    id: 2,
    title: "Design & Engineering",
    steps: [
      { title: "Plant capacity sizing (0.5–2 MW)", image: s2step1 },
      { title: "Module / inverter selection", image: s2step2 },
      { title: "Array layout & string configuration", image: s2step3 },
      { title: "SLDs, cable sizing & electrical schematics", image: s2step4 },
      { title: "Grid study & protection system planning", image: s2step5 },
    ],
  },
  {
    id: 3,
    title: "Financial Modelling",
    steps: [
      { title: "Tariff modelling & revenue forecast", image: s3step1 },
      { title: "CAPEX planning / investor structuring", image: s3step2 },
      { title: "PPA scenario planning with DISCOM", image: s3step3 },
      { title: "IRR, payback & risk mapping", image: s3step4 },
      { title: "Bankability & funding prep", image: s3step5 },
    ],
  },
  {
    id: 4,
    title: "Documentation Prep",
    steps: [
      { title: "Land records, KYC, ownership proofs", image: s4step1 },
      { title: "CAPEX Survey documents, FMB/layout maps", image: s4step2 },
      { title: "Required DISCOM formats", image: s4step3 },
      { title: "MNRE eligibility documents", image: s4step4 },
      { title: "Draft PPA review & preparation planning / investor structuring", image: s4step5 },
    ],
  },
  {
    id: 5,
    title: "Applications & Approvals",
    steps: [
      { title: "MNRE / State portal application", image: s5step1 },
      { title: "DISCOM feasibility approval", image: s5step2 },
      { title: "CEIG/CEA compliance planning", image: s5step3 },
      { title: "Approval tracker inside TrueTrack™", image: s5step4 },
      { title: "Real-time status visible to client", image: s5step5 },
    ],
  },
  {
    id: 6,
    title: "Engineering & Procurement",
    steps: [
      { title: "Final BOQ & vendor locking", image: s6step1 },
      { title: "Module, inverter, transformer, MMS procurement", image: s6step2 },
      { title: "Delivery schedules tracked in-app", image: s6step3 },
      { title: "Civil design, geotechnical validation", image: s6step4 },
      { title: "Digital QA of materials before dispatch", image: s6step5 },
    ],
  },
  {
    id: 7,
    title: "EPC Execution",
    steps: [
      { title: "Daily site logs: photos, videos, progress %", image: s7step1 },
      { title: "Civil, MMS, DC & AC milestones tracked digitally", image: s7step2 },
      { title: "Workfront readiness & manpower mapping", image: s7step3 },
      { title: "Material movement & consumption", image: s7step4 },
      { title: "Automated alerts for delays", image: s7step5 },
      { title: "Client dashboard: complete transparency", image: s7step6 },
    ],
  },
  {
    id: 8,
    title: "Testing & Commissioning",
    steps: [
      { title: "Module/inverter testing & safety validation", image: s8step1 },
      { title: "Transformer, HT panel, LT panel testing", image: s8step2 },
      { title: "Meter installation & DISCOM coordination", image: s8step3 },
      { title: "CEIG inspection & approvals", image: s8step4 },
      { title: "Grid synchronization and final energization", image: s8step5 },
      { title: "Handover package auto-generated", image: s8step6 },
    ],
  },
  {
    id: 9,
    title: "Live Monitoring",
    steps: [
      { title: "Real-time generation, PR, CUF & grid export", image: s9step1 },
      { title: "Inverter / string-level diagnostics", image: s9step2 },
      { title: "Weather, temperature & soiling impact modeling", image: s9step3 },
      { title: "AI alerts for underperformance", image: s9step4 },
      {
        title: "Dual dashboards:",
        image: s9step5,
        bullets: [
          "Engineering dashboard (SCADA, granular data)",
          "Owner dashboard (simple uptime, generation, savings)"
        ]
      },
    ],
  },
  {
    id: 10,
    title: "Maintenance & Asset Health",
    steps: [
      { title: "Preventive maintenance scheduling (cleaning, tightening, vegetation)", image: s10step1 },
      { title: "Corrective maintenance with SLA-bound ticketing", image: s10step2 },
      { title: "Thermography & drone inspections", image: s10step3 },
      { title: "AC & DC side servicing logs", image: s10step4 },
      { title: "Monthly digital plant health reports", image: s10step5 },
      { title: "Downtime, root cause analysis, corrective actions", image: s10step6 },
    ],
  },
  {
    id: 11,
    title: "Billing & Settlements",
    steps: [
      { title: "Automated monthly energy billing", image: s11step1 },
      { title: "Export energy reconciliation with DISCOM", image: s11step2 },
      { title: "Payment tracking & due-date reminders", image: s11step3 },
      { title: "Revenue dashboards for investors", image: s11step4 },
      { title: "Monthly PPA performance", image: s11step5 },
      { title: "Energy accounting for audits", image: s11step6 },
    ],
  },
  {
    id: 12,
    title: "Lifecycle Reporting",
    steps: [
      { title: "Monthly & annual performance reports", image: s12step1 },
      { title: "PPA compliance documentation", image: s12step2 },
      { title: "CEIG/CEA renewal reminders", image: s12step3 },
      { title: "Data exports for banks, auditors & government", image: s12step4 },
      { title: "Carbon credit & REC eligibility mapping", image: s12step5 },
      { title: "Long-term asset performance benchmarking", image: s12step6 },
    ],
  },
];

const N = stages.length;
const RADIUS = 380;
const ANGLE_STEP = 30;
const MINOR_TICKS = 72;

const HowItWorks = () => {
  const sectionRef = useRef(null);

  const dialRef = useRef(null);
  const numRefs = useRef([]);
  const tickRefs = useRef([]);
  const itemRefs = useRef([]);
  const cardsContainerRef = useRef(null);
  const arcRef = useRef(null);

  const activeStageRef = useRef(0);
  const logoRef = useRef(null);

  const [activeIdx, setActiveIdx] = useState(0);
  const [isMobilePopupOpen, setIsMobilePopupOpen] = useState(false);

  useEffect(() => {
    let raf;
    const update = () => {
      const el = sectionRef.current;
      if (!el) return;

      const rect = el.getBoundingClientRect();
      const headerEl = el.querySelector(".hiw-header-wrap");
      const headerHeight = headerEl ? headerEl.offsetHeight : 0;

      const startDelay = headerHeight + window.innerHeight * 0.2;
      const totalScroll = el.offsetHeight - window.innerHeight - startDelay;
      const scrolled = -rect.top - startDelay;

      const p = Math.max(0, Math.min(scrolled / totalScroll, 1));
      const arcFloat = p * N;
      const activeFloat = Math.min(arcFloat, N - 1);
      const activeIndex = Math.round(activeFloat);

      const currentRotation = -(activeFloat * ANGLE_STEP);
      const mobileOffset = window.innerWidth <= 1024 ? -90 : 0;

      if (dialRef.current) {
        dialRef.current.style.transform = `translate(-50%, -50%) rotate(${currentRotation + mobileOffset}deg)`;
      }

      if (logoRef.current) {
        const logoOffset = window.innerWidth <= 1024 ? 90 : 0;
        logoRef.current.style.transform = `rotate(${currentRotation + logoOffset}deg)`;
      }

      stages.forEach((_, i) => {
        const numEl = numRefs.current[i];
        const tickEl = tickRefs.current[i];
        const itemEl = itemRefs.current[i];
        if (!numEl || !tickEl || !itemEl) return;

        const dist = activeFloat - i;
        let opacity = 1;

        if (Math.abs(dist) < 0.5) {
          opacity = 0;
        } else if (dist > 0.5) {
          opacity = Math.max(0, 1 - (dist - 0.5) * 0.4);
        } else if (dist < -5) {
          opacity = 0;
        }

        numEl.style.opacity = opacity;
        tickEl.style.opacity = 1;
        itemEl.style.opacity = opacity;

        numEl.style.transform = `rotate(${-(i * ANGLE_STEP) - currentRotation - mobileOffset}deg)`;
      });

      if (arcRef.current) {
        const progress = Math.max(0, Math.min(arcFloat, N)) / 12;
        const circ = 2 * Math.PI * 333;
        arcRef.current.style.strokeDashoffset = circ - progress * circ;
      }

      if (activeIndex !== activeStageRef.current) {
        activeStageRef.current = activeIndex;
        setActiveIdx(activeIndex);
      }

      raf = requestAnimationFrame(update);
    };

    const onScroll = () => {
      if (!raf) raf = requestAnimationFrame(update);
    };

    setTimeout(() => update(), 100);
    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  const currentStage = stages[activeIdx];
  const numStr = (activeIdx + 1).toString().padStart(2, "0");
  const cardsData = currentStage.steps;

  const scrollCards = (direction) => {
    if (cardsContainerRef.current) {
      const scrollAmount = cardsContainerRef.current.offsetWidth;
      cardsContainerRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <div
      className="hiw-outer"
      ref={sectionRef}
      style={{ height: `${stages.length * 60}vh` }}
    >
      <div className="hiw-header-wrap">
        <div className="hiw-tag">
          <span className="hiw-dot"></span>
          HOW IT WORKS
        </div>
        <h2 className="hiw-title">
          True 360° Execution —<br />
          Zero-Stress, End-to-End Solar
        </h2>
        <p className="hiw-subtitle">
          A transparent, predictable, 12-stage execution framework that ensures
          every project — Government, Corporate or Residential — is delivered
          with absolute clarity and control.
        </p>
      </div>

      <div className="hiw-sticky">
        <div className="hiw-split">
          {/* LEFT SIDE: DIAL */}
          <div className="hiw-left">
            <div className="hiw-mobile-header">
              <div className="hiw-tag">
                <span className="hiw-dot"></span>
                HOW IT WORKS
              </div>
              <h2 className="hiw-title">
                True 360° Execution —<br />
                Zero-Stress, End-to-End Solar
              </h2>
              <p className="hiw-subtitle">
                A transparent, predictable, 12-stage execution framework that
                ensures every project — Government, Corporate or Residential —
                is delivered with absolute clarity and control.
              </p>
            </div>

            <div className="hiw-dial-wrapper">
              <div className="hiw-dial-container" ref={dialRef}>
                <div className="hiw-dial-bg"></div>
                <div className="hiw-dial-inner-orange"></div>

                {Array.from({ length: MINOR_TICKS }).map((_, i) => (
                  <div
                    key={`tick-${i}`}
                    className="hiw-dial-tick-min"
                    style={{
                      transform: `rotate(${i * (360 / MINOR_TICKS)}deg) translate(${RADIUS}px)`,
                    }}
                  />
                ))}

                <svg
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "678px",
                    height: "678px",
                    pointerEvents: "none",
                    zIndex: 2,
                  }}
                >
                  <circle
                    ref={arcRef}
                    cx="339"
                    cy="339"
                    r="333"
                    fill="none"
                    stroke="#F05A28"
                    strokeWidth="6"
                    strokeDasharray={2 * Math.PI * 333}
                    strokeDashoffset={2 * Math.PI * 333}
                    strokeLinecap="round"
                  />
                </svg>

                {stages.map((stage, i) => {
                  const itemAngle = i * ANGLE_STEP;
                  const isActive = i === activeIdx;
                  const isPast = i < activeIdx;

                  return (
                    <React.Fragment key={stage.id}>
                      <div
                        className={`hiw-dial-tick-maj ${isActive ? "active" : ""} ${isPast ? "past" : ""}`}
                        ref={(el) => (tickRefs.current[i] = el)}
                        style={{
                          transform: `rotate(${itemAngle}deg) translate(${RADIUS}px)`,
                        }}
                      />
                      <div
                        className={`hiw-dial-item ${isPast ? "past" : ""}`}
                        ref={(el) => (itemRefs.current[i] = el)}
                        style={{
                          transform: `rotate(${itemAngle}deg) translate(${RADIUS + 40}px)`,
                        }}
                      >
                        <div
                          className="hiw-dial-num"
                          ref={(el) => (numRefs.current[i] = el)}
                          style={{ transform: "rotate(-90deg)" }}
                        >
                          {(i + 1).toString().padStart(2, "0")}
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })}
              </div>

              <div className="hiw-dial-inner">
                <img
                  src={trueRenewablesLogo}
                  alt="True Renewables"
                  className="hiw-center-logo"
                  ref={logoRef}
                  loading="lazy"
                />
                <div className="hiw-dial-pointer"></div>
              </div>

              <div className="hiw-active-overlay">
                <div className="hiw-inner-faint-line"></div>
                <div className="hiw-active-thick-line"></div>
                <div className="hiw-active-dot"></div>
                <div className="hiw-active-text-block">
                  <span className="hiw-active-num">{numStr}</span>
                  <span className="hiw-active-title">{currentStage.title}</span>
                </div>
              </div>
            </div>

            <div className="hiw-mobile-info">
              <div className="hiw-mobile-stage">STAGE {activeIdx + 1}</div>
              <h3 className="hiw-mobile-title">{currentStage.title}</h3>
              <p className="hiw-mobile-desc">
                {currentStage.steps.map((s) => s.title).join(", ")}
              </p>
              <button
                className="hiw-mobile-view-btn"
                onClick={() => setIsMobilePopupOpen(true)}
              >
                VIEW DETAILS ↗
              </button>
            </div>
          </div>

          {/* RIGHT SIDE: CONTENT */}
          <div className={`hiw-right ${isMobilePopupOpen ? "mobile-open" : ""}`}>
            <div
              className="hiw-popup-bg"
              onClick={() => setIsMobilePopupOpen(false)}
            ></div>
            <div className="hiw-popup-inner">
              <button
                className="hiw-popup-close"
                onClick={() => setIsMobilePopupOpen(false)}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>

              <div className="hiw-stage-badge">STAGE {numStr}</div>
              <h2 className="hiw-right-title">{currentStage.title}</h2>

              <div className="hiw-cards-container" ref={cardsContainerRef}>
                {cardsData.map((step, idx) => (
                  <div key={idx} className="hiw-step-card">
                    <div className="hiw-step-img-wrap">
                      <img
                        src={step.image}
                        alt={step.title}
                        className="hiw-step-img"
                        loading="lazy"
                      />
                    </div>
                    <div className="hiw-step-text">
                      <p className="hiw-step-num">STEP {idx + 1}</p>
                      <h4 className="hiw-step-title">{step.title}</h4>
                      {step.bullets && (
                        <ul className="hiw-step-bullets">
                          {step.bullets.map((bullet, i) => (
                            <li key={i} className="hiw-step-bullet">{bullet}</li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              <div className="hiw-nav-arrows">
                <button
                  type="button"
                  className="hiw-nav-arrow"
                  onClick={() => scrollCards("left")}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="15 18 9 12 15 6"></polyline>
                  </svg>
                </button>
                <button
                  type="button"
                  className="hiw-nav-arrow"
                  onClick={() => scrollCards("right")}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </button>
              </div>

              <div className="hiw-popup-mobile-info">
                <div className="hiw-mobile-stage">STAGE {activeIdx + 1}</div>
                <h3 className="hiw-mobile-title">{currentStage.title}</h3>
                <p className="hiw-mobile-desc">
                  {currentStage.steps.map((s) => s.title).join(", ")}
                </p>
                <button
                  className="hiw-mobile-view-btn popup-btn"
                  onClick={() => setIsMobilePopupOpen(false)}
                >
                  VIEW DETAILS ↗
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const complianceTabs = [
  {
    id: "regulatory",
    label: "Regulatory",
    img: complianceImg1,
    title: "Regulatory",
    checks: [
      "CEIG",
      "DISCOM",
      "SLDC",
      "Open-Access",
      "Grid Synchronization",
      "Metering & inspection",
    ],
  },
  {
    id: "billing",
    label: "Billing & Financial",
    img: complianceImg2,
    title: "Billing & Financial",
    checks: [
      "OA Charges",
      "Banking/Wheeling",
      "Net Metering",
      "Invoicing",
      "EMI Tracking",
      "Payment Reminders",
      "Energy Accounting",
    ],
  },
];

const AboutComplianceBilling = () => {
  const [activeTab, setActiveTab] = useState("regulatory");
  const sectionRef = useRef(null);
  const leftRef = useReveal();
  const active = complianceTabs.find((t) => t.id === activeTab);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;

    const onScroll = () => {
      const rect = section.getBoundingClientRect();
      const totalScroll = section.offsetHeight - window.innerHeight;
      const scrolled = -rect.top;
      const progress = scrolled / totalScroll;
      setActiveTab(progress >= 0.5 ? "billing" : "regulatory");
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="about-comp-scroll-wrapper" ref={sectionRef}>
      <section className="about-comp">
        <div className="about-comp-inner about-comp-desktop">
          {/* ── LEFT ── */}
          <div className="about-comp-left reveal-block" ref={leftRef}>
            <div className="about-comp-left-header">
              <p className="about-comp-tag">
                <span className="about-comp-dot" />
                DIGITAL COMPLIANCE &amp; BILLING
              </p>
              <h2 className="about-comp-title">
                Compliance, Approvals &amp; Billing
                <br />
                — Fully Automated
              </h2>
              <p className="about-comp-subtitle">
                Solar is not just engineering. It is approvals, filings, submissions, inspections, and settlements. We handle everything with zero client involvement.
              </p>
            </div>

            <div className="about-comp-tabs">
              {complianceTabs.map((tab) => (
                <button
                  key={tab.id}
                  className={`about-comp-tab${activeTab === tab.id ? " about-comp-tab--active" : ""}`}
                  onClick={() => setActiveTab(tab.id)}
                >
                  {activeTab === tab.id && (
                    <span className="about-comp-tab-bar" />
                  )}
                  <span className="about-comp-tab-label">{tab.label}</span>
                </button>
              ))}
            </div>

            <p className="about-comp-tagline">
              All automated inside TrueCom™.
              <br />
              You don't worry about anything. You just see results.
            </p>
          </div>

          {/* ── RIGHT ── */}
          <div className="about-comp-right">
            <img
              src={active.img}
              alt={active.title}
              className="about-comp-right-img"
              loading="lazy"
            />
            <p className="about-comp-right-title">{active.title}</p>
            <ul className="about-comp-checklist">
              {active.checks.map((c, i) => (
                <li key={i} className="about-comp-check-item">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="about-comp-check-icon"
                  >
                    <path
                      d="M5 12L10 17L19 7"
                      stroke="#C04820"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  {c}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* ── MOBILE accordion layout ── */}
        <div className="about-comp-mobile">
          <div className="about-comp-mobile-header">
            <p className="about-comp-tag">
              <span className="about-comp-dot" />
              DIGITAL COMPLIANCE &amp; BILLING
            </p>
            <h2 className="about-comp-title">Compliance, Approvals &amp; Billing — Fully Automated</h2>
            <p className="about-comp-subtitle">
              Solar is not just engineering. It is approvals, filings, submissions, inspections, and settlements. We handle everything with zero client involvement.
            </p>
          </div>

          {[...complianceTabs]
            .sort((a) => (a.id === activeTab ? -1 : 1))
            .map((tab, idx) => (
              <div
                key={tab.id}
                className={`about-comp-acc-item${activeTab === tab.id ? " about-comp-acc-item--active" : ""}${idx === 0 ? " about-comp-acc-item--first" : ""}`}
              >
                <button
                  className="about-comp-acc-trigger"
                  onClick={() => setActiveTab(tab.id)}
                >
                  {activeTab === tab.id && (
                    <span className="about-comp-tab-bar" />
                  )}
                  <span className="about-comp-tab-label">{tab.label}</span>
                </button>

                {activeTab === tab.id && (
                  <div className="about-comp-acc-content">
                    <ul className="about-comp-checklist">
                      {tab.checks.map((c, i) => (
                        <li key={i} className="about-comp-check-item">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="about-comp-check-icon"
                          >
                            <path
                              d="M5 12L10 17L19 7"
                              stroke="#C04820"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                          {c}
                        </li>
                      ))}
                    </ul>
                    <img
                      src={tab.img}
                      alt={tab.title}
                      className="about-comp-acc-img"
                      loading="lazy"
                    />
                  </div>
                )}
              </div>
            ))}
        </div>
      </section>
    </div>
  );
};

const platformLeftRow1 = ["Plant Owners", "Industries"];
const platformLeftRow2 = ["Group Captive Owners", "Residential Costumers"];
const platformRightRow1 = ["DISCOM", "Investors"];
const platformRightRow2 = ["Industries", "Farmers"];

const AboutStakeholderPlatform = () => {
  const headerRef = useReveal();

  return (
    <section className="about-sw-section">
      <div className="about-sw-header-wrap reveal-block" ref={headerRef}>
        <p className="about-sw-tag">
          <span className="about-sw-dot" />
          DIGITAL PLATFORM
        </p>
        <h2 className="about-sw-title">
          A Unified Platform For
          <br />
          All Stakeholders
        </h2>
        <p className="about-sw-subtitle">Whether it's:</p>
      </div>

      <div className="about-sw-orbit">
        {/* Left pills — scroll rightward toward center */}
        <div className="about-sw-side about-sw-side--left">
          <div className="about-sw-row">
            <div className="about-pills-track about-pills-track--right">
              {[
                ...platformLeftRow1,
                ...platformLeftRow1,
                ...platformLeftRow1,
                ...platformLeftRow1,
                ...platformLeftRow1,
                ...platformLeftRow1
              ].map((label, i) => (
                <span className="about-sw-pill" key={`lr1-${i}`}>
                  {label}
                </span>
              ))}
            </div>
          </div>
          <div className="about-sw-row">
            <div className="about-pills-track about-pills-track--right about-pills-track--delay">
              {[
                ...platformLeftRow2,
                ...platformLeftRow2,
                ...platformLeftRow2,
                ...platformLeftRow2,
                ...platformLeftRow2,
                ...platformLeftRow2
              ].map((label, i) => (
                <span className="about-sw-pill" key={`lr2-${i}`}>
                  {label}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Center logo card */}
        <div className="about-sw-center">
          <div className="about-sw-logo-card">
            <img
              src={truerenewableslogo}
              alt="True Renewables"
              className="about-sw-logo"
              loading="lazy"
            />
          </div>
        </div>

        {/* Right pills — scroll leftward toward center */}
        <div className="about-sw-side about-sw-side--right">
          <div className="about-sw-row">
            <div className="about-pills-track about-pills-track--left">
              {[
                ...platformRightRow1,
                ...platformRightRow1,
                ...platformRightRow1,
                ...platformRightRow1,
                ...platformRightRow1,
                ...platformRightRow1
              ].map((label, i) => (
                <span className="about-sw-pill" key={`rr1-${i}`}>
                  {label}
                </span>
              ))}
            </div>
          </div>
          <div className="about-sw-row">
            <div className="about-pills-track about-pills-track--left about-pills-track--delay">
              {[
                ...platformRightRow2,
                ...platformRightRow2,
                ...platformRightRow2,
                ...platformRightRow2,
                ...platformRightRow2,
                ...platformRightRow2
              ].map((label, i) => (
                <span className="about-sw-pill" key={`rr2-${i}`}>
                  {label}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      <p className="about-sw-footer">
        Everyone sees the same truth: <strong>Same Data,</strong>
        <br />
        <strong>Same Dashboards, Same Reports.</strong>
      </p>
    </section>
  );
};

const modularCards = [
  {
    img: modularImg1,
    title: "Rooftop (Commercial + Residential)",
  },
  {
    img: modularImg2,
    title: "Captive",
  },
  {
    img: modularImg3,
    title: "Group Captive",
  },
  {
    img: modularImg4,
    title: "Open Access",
  },
  {
    img: modularImg5,
    title: "Utility-scale Solar",
  },
  {
    img: modularImg6,
    title: "Government Programs",
  },
  {
    img: modularImg7,
    title: "EV Charging Integration",
  },
  {
    img: modularImg8,
    title: "Battery + hybrid energy systems",
  },
];

const AboutModularSolutions = () => {
  const headerRef = useReveal();

  return (
    <section className="about-mod">
      <div className="about-mod-header">
        <p className="about-mod-tag">
          <span className="about-mod-dot" />
          MODULAR SOLUTIONS
        </p>
        <h2 className="about-mod-title">
          Modular Solutions for Every
          <br />
          User — From Homes to Industries
        </h2>
        <p className="about-mod-desc">
          You choose the requirement. We deliver a complete solution.
        </p>
      </div>

      <div className="about-mod-scroll">
        {modularCards.map((card, i) => (
          <div className="about-mod-card" key={i}>
            <div className="about-mod-card-img-wrap">
              <img
                src={card.img}
                alt={card.title}
                className="about-mod-card-img"
                loading="lazy"
              />
            </div>
            <div className="about-mod-card-text">
              <h3 className="about-mod-card-title">{card.title}</h3>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

const AboutDesignIntelligence = () => {
  const headerRef = useReveal();
  const sectionRef = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const callouts = [
    {
      side: "left",
      label: "Microinverter architecture for shade",
      labelBreak: "Microinverter architecture\nfor shade",
      style: { top: "14.9%", right: "88.3%" },
    },
    {
      side: "left",
      label: "Smart battery ecosystems",
      style: { top: "46.5%", right: "85.3%" },
    },
    {
      side: "left",
      label: "Integrated energy automation",
      style: { top: "75%", right: "84.2%" },
    },
    {
      side: "right",
      label: "All-black panels for villas",
      style: { top: "19.7%", left: "94.3%" },
    },
    {
      side: "right",
      label: "Elevated structures for usable terrace",
      labelBreak: "Elevated structures for\nusable terrace",
      style: { top: "60.1%", left: "88.5%" },
    },
    {
      side: "right",
      label: "Solar carports",
      style: { top: "88.3%", left: "84.2%" },
    },
  ];

  return (
    <section className="about-design" ref={sectionRef}>
      <div className="about-design-header reveal-block" ref={headerRef}>
        <p className="about-design-tag">
          <span className="about-design-dot" />
          AESTHETICALLY ENGINEERED
        </p>
        <h2 className="about-design-title">Design Meets Intelligence</h2>
        <p className="about-design-subtitle">
          Solar that looks beautiful, performs better, and lasts longer.
        </p>
      </div>

      <div className="about-design-body">
        <div className="about-design-image-container">
          <img
            src={about10}
            alt="All-black solar panels for villas"
            className="about-design-image"
            loading="lazy"
          />
          {/* Overlay target callout dots, lines, and labels */}
          {callouts.map((c, i) => (
            <div
              key={i}
              className={`about-design-callout about-design-callout--${c.side} ${
                inView ? "about-design-callout--active" : ""
              }`}
              style={{
                ...c.style,
                "--delay": `${i * 0.4}s`
              }}
            >
              <span className="about-design-callout-outer">
                <span className="about-design-callout-inner" />
              </span>
              <span className="about-design-callout-line" />
              <span className="about-design-callout-label">
                {(c.labelBreak || c.label).split("\n").map((line, idx) => (
                  <React.Fragment key={idx}>
                    {idx > 0 && <br />}
                    {line}
                  </React.Fragment>
                ))}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Responsive mobile feature list */}
      <div className="about-design-mobile-list">
        {callouts.map((c, i) => (
          <div className="about-design-mobile-item" key={i} style={{ "--delay": `${i * 0.2}s` }}>
            <span className={`about-design-mobile-dot ${inView ? "about-design-mobile-dot--active" : ""}`} />
            <span className="about-design-mobile-text">{c.label}</span>
          </div>
        ))}
      </div>

      <p className="about-design-footer">
        A perfect balance of <strong>Engineering + Architecture.</strong>
      </p>
    </section>
  );
};

const promiseItems = [
  "One Company",
  "One Platform",
  "One Execution Flow",
  "One Monitoring System",
  "One Commercial Dashboard",
  "One Long-term Service Partner",
];

const AboutPromise = () => {
  const leftRef = useReveal();

  return (
    <section className="about-promise">
      <div className="about-promise-inner">
        <div className="about-promise-left reveal-block" ref={leftRef}>
          <div className="about-promise-header">
            <p className="about-promise-tag">
              <span className="about-promise-dot" />
              OUR PROMISE
            </p>
            <h2 className="about-promise-title">
              A Promise Of Zero Stress.
              <br />
              Zero Hassle. Zero Uncertainty.
            </h2>
          </div>

          <p className="about-promise-sub">True Renewables gives you:</p>

          <ul className="about-promise-list">
            {promiseItems.map((item, i) => (
              <li key={i} className="about-promise-list-item">
                <svg
                  className="about-promise-check"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4 12.5L9.5 18L20 7"
                    stroke="#C04820"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                {item}
              </li>
            ))}
          </ul>
        </div>

        <div className="about-promise-img-wrap">
          <div className="about-promise-img-bg" />
          <img
            src={about11}
            alt="Promise of Zero Stress"
            className="about-promise-img"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

const AboutUs = () => {
  useEffect(() => {
    document.body.classList.add("about-page");

    return () => {
      document.body.classList.remove("about-page");
    };
  }, []);

  return (
    <>
      <AboutHero />
      <AboutExplainer />
      <AboutEcosystem />
      <AboutWhyChooseUs />
      <AboutCapabilities />
      <HowItWorks />
      <AboutComplianceBilling />
      <AboutStakeholderPlatform />
      <AboutModularSolutions />
      <AboutDesignIntelligence />
      <AboutPromise />
    </>
  );
};


export default AboutUs;
